export const getDataSDKFromF88 = async () => {
  return {
    data: {},
    error: null
  }
}
